/* tslint:disable */

/**
 */
export class TimeBasedLabel {
    top?: string;
    int?: string;
    bot?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/time-based-label.ts